import { Col, Container, Row } from 'react-bootstrap';

import ComingSoon from '../../assets/svg/ComingSoon';
const ComingSoonComponent = () => {
  return (
    <Container className="cs-tile">
      <Row>
        <Col className="d-flex justify-content-center mt-5 mb-5" xs={4} lg={2}>
          <ComingSoon />
        </Col>
        <Col className="mt-5 pt-4" xs={8} lg={10}>
          <h3>Nous travaillons dur pour vous offrir le meilleur service.</h3>
          <p>Cette rubrique sera bientôt disponible !</p>
        </Col>
      </Row>
    </Container>
  );
};

export default ComingSoonComponent;
